import { TEACHER_HEADER_MENU_ITEMS } from '../../teacher-header-menu';

export enum NOTIFICATION_TYPE {
    TEAM_UPDATED = 'team_updated',
    TEAM_DELETED = 'team_deleted',
    TEAM_ARCHIVED = 'team_archived',
    TEAM_UNARCHIVED = 'team_unarchived',
    TEAM_ACCESS_REVOKED = 'team_access_revoked',
    SCHOOL_CODE_UPDATED = 'school_code_updated',
    STREAM_LESSONS_CANCELLED = 'stream_lessons_cancelled',
    MESSENGER_CLOSING = 'chat_should_be_removed',
    MESSENGER_CLOSED = 'chat_is_removed',
    WEBINAR_INVITATION = 'webinar_invitation',
    STUDENT_RESULTS_AVAILABLE = 'student_result_available',
    STUDENT_AWARDS_AVAILABLE = 'student_awards_for_several_lessons_available',
    STUDENT_AWARDS_AVAILABLE_NEW = 'student_awards_for_several_multi_lessons_available',
    STUDENT_NEW_STICKERS_AVAILABLE = 'student_new_stickers_available',
    LESSON_HAS_BEEN_VIEWED = 'lesson_has_been_viewed',
    INTERFACE_ELEMENT_UNREAD = 'interface_element_unread',
}

export enum LESSON_VIEWED_NOTIFICATION_ID {
    OLYMP = 'olymp',
}

export type DefaultNotificationData = {
    team_id: number;
    name: string;
    level: number;
}

export type ClessonNavigationNotificationData = {
    clessonId?: number;
    courseId?: number;
    lessonName?: string;
    slug?: string;
}

export type ClessonsAwardsNotificationData = {
    courseId: number;
    clessonId: {
        winner?: number[];
        awardee?: number[];
        participant?: number[];
    },
    // campaign slug
    slug: string;
    lessons_meta_slugs?: string[];
}

export type ClessonViewedNotificationData = {
    course_id: number;
    clesson_id: number;
    lesson_meta_slug: string;
    identifier: LESSON_VIEWED_NOTIFICATION_ID;
}

export type InterfaceElementUnreadNotificationData = {
    element_identifier: TEACHER_HEADER_MENU_ITEMS;
}

export type Notification<Data = DefaultNotificationData> = {
    id: number;
    type_slug: NOTIFICATION_TYPE;
    data: Data;
}

export type NotificationDataType =
    DefaultNotificationData |
    ClessonNavigationNotificationData |
    ClessonsAwardsNotificationData |
    ClessonViewedNotificationData |
    InterfaceElementUnreadNotificationData;
